import { useState } from "react";
import { ChevronLeft, ChevronRight, RotateCcw } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Flashcards({ cards }) {
  const [idx, setIdx] = useState(0);
  const [flipped, setFlipped] = useState(false);

  const card = cards[idx];
  const go = (dir) => {
    setFlipped(false);
    setTimeout(() => setIdx((p) => (p + dir + cards.length) % cards.length), 120);
  };

  return (
    <div className="space-y-5" data-testid="flashcard-deck">
      <div className="text-xs text-muted-foreground text-center font-medium">
        Carta {idx + 1} di {cards.length} — tocca per girare
      </div>
      <div className="flip-card h-64 sm:h-72 cursor-pointer" onClick={() => setFlipped((f) => !f)} data-testid="flashcard">
        <div className={`flip-inner h-full w-full ${flipped ? "flipped" : ""}`}>
          <div className="flip-face h-full w-full rounded-2xl border-2 border-border bg-card flex items-center justify-center p-6 text-center shadow-sm">
            <div>
              <div className="text-xs uppercase tracking-wider text-muted-foreground mb-3">Domanda</div>
              <p className="font-display text-lg sm:text-xl font-bold leading-snug">{card.front}</p>
            </div>
          </div>
          <div className="flip-face flip-back h-full w-full rounded-2xl border-2 border-primary/40 bg-accent flex items-center justify-center p-6 text-center shadow-sm">
            <div>
              <div className="text-xs uppercase tracking-wider text-primary mb-3">Risposta</div>
              <p className="text-[15px] leading-relaxed text-foreground">{card.back}</p>
            </div>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-between">
        <Button data-testid="flashcard-prev" variant="secondary" size="icon" className="rounded-xl" onClick={() => go(-1)}>
          <ChevronLeft className="h-4 w-4" />
        </Button>
        <Button data-testid="flashcard-reset" variant="ghost" className="rounded-xl gap-2 text-sm" onClick={() => { setIdx(0); setFlipped(false); }}>
          <RotateCcw className="h-3.5 w-3.5" /> Ricomincia
        </Button>
        <Button data-testid="flashcard-next" variant="secondary" size="icon" className="rounded-xl" onClick={() => go(1)}>
          <ChevronRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
